export interface IMillReportCardProps {
    countryCode: string | undefined;
}

/** Report families on the mill Reports tab; OEE is offered only to mills with the ASPEN+ module enabled. */
export enum ReportTypeEnum {
    availability = "availability",
    oee = "oee",
}
